export const STORE_POSTLIST = 'STORE_POSTLIST'
export const STORE_COMMENTS = 'STORE_COMMENTS'
export const STORE_COUNT = 'STORE_COUNT'
